import { auth } from '@/store/authStore';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = auth.isAuthenticated();
  const location = useLocation();

  if (!isAuthenticated) {
    const parentArea = location.pathname.startsWith('/my-bookings') || location.pathname.startsWith('/parent');
    return <Navigate to={parentArea ? '/parent/login' : '/login'} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 
